<i18n src="@/locales/modules/TodoListTranslate.json"></i18n>

<template>
	<div>
		<el-dialog append-to-body destroy-on-close class="custom-dialog" :visible.sync="isSidebarActiveLocal" :before-close="setDialogHide => handleCloseDialog(setDialogHide, isFormDirty)">
			<div slot="title">
				<h4 class="uppercase font-bold block text-xl w-full">{{ $t("Watcher") }}</h4>
				<p class="text-base text-black font-medium">{{ todo.name }}</p>
			</div>
			<perfect-scrollbar ref="vueScrollBar" class="scroll-area--data-list">
				<div class="px-8 py-4">
					<AddWatchersRef v-if="isSidebarActiveLocal" v-model="watchers" />
				</div>
			</perfect-scrollbar>

			<div class="flex justify-center flex-wrap items-center" slot="footer">
				<vs-button class="w-full sm:w-1/3 mb-3 sm:mb-0 sm:mr-6 font-bold" @click.stop="saveWatcher">
					{{ $t("Actions.Save") }}
				</vs-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import * as _ from "lodash";
import { showConfirm, detectLeavePage } from "@/mixins/mixins.js";

import AddWatchersRef from "@/components/add-watchers-ref/AddWatchersRef";

export default {
	name: "TodoWatcherDialog",
	mixins: [showConfirm, detectLeavePage("isFormDirty")],

	provide() {
		return { parentValidator: this.$validator };
	},
	props: {
		todo: {
			type: Object,
			required: true
		},
		isSidebarActive: {
			type: Boolean,
			required: true
		}
	},
	components: { AddWatchersRef },
	data() {
		return {
			watchers: [],
			isFormDirty: false,
			initWatchers: []
		};
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			}
		},
		isHasUnsavedWatcher() {
			return !!this.watchers.find(watcher => !watcher.relations.length > 0);
		},
		trackingIsFormDirtyData() {
			return { watchers: this.watchers, initWatchers: this.initWatchers };
		}
	},
	watch: {
		trackingIsFormDirtyData: {
			handler: function(newVal) {
				this.isFormDirty = JSON.stringify(newVal.watchers) !== JSON.stringify(newVal.initWatchers) || this.isHasUnsavedWatcher;
			},
			deep: true
		}
	},
	methods: {
		async saveWatcher() {
			const result = await this.$validator.validateAll();
			if (!result) return;
			this.$vs.loading();
			const dataObj = {
				id: this.todo.id,
				name: this.todo.name,
				watchers: this.watchers
					.filter(watcher => watcher.relations && watcher.relations.length)
					.map(watcher => {
						delete watcher.hashtag_content;
						return {
							...watcher,
							relations: watcher.relations && watcher.relations.length && watcher.relations.map(relation => ({ id: relation.id, type: relation.type }))
						};
					})
			};
			try {
				const response = await this.$store.dispatch("todoListManagement/updateTodoItemWatcher", dataObj);
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("UpdateWatcherSuccessful")
					}
				});

				this.watchers = this.renderWatcherFromServer(response.watchers);
				this.initWatchers = _.cloneDeep(this.watchers);
				this.$emit("onUpdateWatcherSuccess");
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$nextTick(() => this.$vs.loading.close());
			}
		},

		renderWatcherFromServer(watchers) {
			return watchers.map(watch => {
				delete watch.__typename;
				delete watch.reminded_at;
				watch.content = watch.hashtag_content || "";
				return watch;
			});
		}
	},
	created() {
		this.watchers = this.renderWatcherFromServer(this.todo.watchers);
		this.initWatchers = _.cloneDeep(this.watchers);
	}
};
</script>

<style></style>
